import React from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight } from "lucide-react";
import { townPath } from "../../towns";

const NEARBY = [
  ["Hamilton", "Our home base — websites and social media for Hamilton businesses, big and small."],
  ["Motherwell", "Local web design and social media management for Motherwell companies."],
  ["Wishaw", "Affordable websites from £99 for Wishaw traders and shops."],
  ["Bothwell", "Stylish, mobile-friendly websites for Bothwell businesses."],
  ["Uddingston", "Web design and Google-friendly sites for Uddingston firms."],
  ["Blantyre", "New websites and redesigns for businesses in Blantyre."],
  ["Bellshill", "Websites and social media that bring Bellshill customers to you."],
  ["East Kilbride", "Web design and e-commerce for East Kilbride businesses."],
  ["Larkhall", "Simple, professional websites for Larkhall tradespeople."],
  ["Stonehouse", "Get your Stonehouse business found online with a new website."],
  ["Strathaven", "Websites and online shops for Strathaven businesses."],
  ["Carluke", "Local web design and social media for Carluke companies."],
  ["Shotts", "Affordable websites that help Shotts businesses grow."],
  ["Newarthill", "Friendly, local web design for businesses in Newarthill."],
  ["Holytown", "Mobile-ready websites for Holytown traders and services."],
  ["Viewpark", "Websites and social media management for Viewpark businesses."],
  ["Coatbridge", "Web design and local SEO for Coatbridge businesses."],
  ["Airdrie", "Modern websites and online shops for Airdrie businesses."],
  ["Cambuslang", "Websites and social media marketing for Cambuslang firms."],
  ["Rutherglen", "Professional web design for businesses in Rutherglen."],
];

const ALSO = ["Lanark", "Biggar", "Cumbernauld", "Glasgow", "Across Scotland"];

export default function AreasServed() {
  return (
    <section id="areas" data-testid="areas-section" className="py-20 lg:py-24 bg-white border-t border-slate-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <span className="section-eyebrow">Areas we serve</span>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-900 leading-[1.05]">
            Web design in Hamilton, Motherwell &amp; every town within 10 miles.
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed">
            We&rsquo;re a local Lanarkshire web designer and social media
            manager. If your business is in or around Hamilton or Motherwell,
            we can meet you in person, build your website and run your social
            media.
          </p>
        </div>

        <ul className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-3" data-testid="areas-nearby-list">
          {NEARBY.map(([town, line]) => {
            const path = townPath(town);
            const body = (
              <>
                <h3 className="flex items-center gap-2 text-sm font-semibold text-slate-900">
                  <MapPin className="h-3.5 w-3.5 text-sky-500 shrink-0" />
                  Web design {town}
                  {path && <ArrowUpRight className="h-3.5 w-3.5 ml-auto text-slate-400 group-hover:text-sky-600 transition-colors" />}
                </h3>
                <p className="mt-1.5 text-xs text-slate-600 leading-relaxed">{line}</p>
              </>
            );
            const cls = "group block h-full p-4 rounded-2xl border border-slate-200 bg-slate-50 hover:bg-white hover:border-sky-300 transition-colors";
            return (
              <li key={town}>
                {path ? (
                  <Link to={path} className={cls} data-testid={`area-link-${path.slice(1)}`}>{body}</Link>
                ) : (
                  <div className={cls}>{body}</div>
                )}
              </li>
            );
          })}
        </ul>

        <div className="mt-8 flex flex-wrap items-center gap-2 text-sm" data-testid="areas-also-serving">
          <span className="text-slate-500 font-medium mr-1">Also serving:</span>
          {ALSO.map((a) => (
            <span key={a} className="px-3 py-1.5 rounded-full border border-slate-200 text-slate-700">
              {a}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
